import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    user: {},
    userSettings: [],
    loaded: false
  }
};
const userInfoSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    getUser: (state, action) => {
      state.value = {
        user: action.payload.user,
        userSettings: state.value.userSettings,
        loaded: true
      };
    },
    loadUserSettings: (state, action) => {
      state.value = {
        user: state.value.user,
        userSettings: action.payload,
        loaded: true
      };
    }
  }
});
export const { getUser, loadUserSettings } = userInfoSlice.actions;
export default userInfoSlice.reducer;
